<template>
<div>
    <Cap/>
    <Header/>
    <!--<Intro/>
    <Contacte/>-->
    <Blog/>
    <Peu/>

</div>
</template>

<script>
import Vue from 'vue'
import { LayoutPlugin } from 'bootstrap-vue'
Vue.use(LayoutPlugin)

    export default {
        name: 'Exemple',
        components: {
        }
    }
</script>


